module.exports = __webpack_public_path__ + "static/media/declined.a2909308.png";